/**
 * PDP FAQ accordion — single-open Radix-style behavior, height-animated via
 * the compiled --radix-accordion-content-height custom property and the
 * accordion-up/down keyframes already present in meliusly-tw.css.
 */
(function () {
  var OPEN_MS = 200;

  function closeItem(wrap) {
    var content = wrap.querySelector('[data-mel-faq-content]');
    var trigger = wrap.querySelector('[data-mel-faq-trigger]');
    if (!content) return;
    var height = content.scrollHeight;
    content.style.setProperty('--radix-accordion-content-height', height + 'px');
    // Force layout so the browser registers the starting height before we animate to 0.
    void content.offsetHeight;
    wrap.setAttribute('data-state', 'closed');
    content.setAttribute('data-state', 'closed');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      if (wrap.getAttribute('data-state') === 'closed') content.hidden = true;
    }, OPEN_MS);
  }

  function openItem(wrap) {
    var content = wrap.querySelector('[data-mel-faq-content]');
    var trigger = wrap.querySelector('[data-mel-faq-trigger]');
    if (!content) return;
    content.hidden = false;
    var height = content.scrollHeight;
    content.style.setProperty('--radix-accordion-content-height', height + 'px');
    wrap.setAttribute('data-state', 'open');
    content.setAttribute('data-state', 'open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function initFaq(section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-mel-faq-trigger]'));
    items.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var wrap = trigger.closest('[data-state]');
        if (!wrap) return;
        var isOpen = wrap.getAttribute('data-state') === 'open';
        // Single-open accordion: close any other open item first.
        Array.prototype.slice.call(section.querySelectorAll('[data-state="open"]')).forEach(function (openWrap) {
          if (openWrap !== wrap) closeItem(openWrap);
        });
        if (isOpen) {
          closeItem(wrap);
        } else {
          openItem(wrap);
        }
      });
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-faq-trigger]')).forEach(function (trigger) {
      var section = trigger.closest('section');
      if (section && !section.hasAttribute('data-mel-faq-bound')) {
        section.setAttribute('data-mel-faq-bound', 'true');
        initFaq(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
